export const COVERAGE_TYPE_OPTIONS = [
    { value: 'maintain', label: 'Maintain' },
    { value: 'cancellation', label: 'Cancellation' },
    { value: 'maintain_and_cancellation', label: 'Maintain and cancellation' },
];

export const REFUND_CALCULATION_BASIS_OPTIONS = [
    { value: 'day', label: 'Day' },
    { value: 'night', label: 'Night' },
];

export const PAYMENT_SCHEDULE_OPTIONS = [
    { value: 'daily', label: 'Daily' },
    { value: 'end_of_stay', label: 'End of Stay' },
];

const normalizeEnum = (value, allowed) => {
    const normalized = String(value || '').trim().toLowerCase();
    if (!normalized) return null;
    return allowed.includes(normalized) ? normalized : null;
};

export const normalizeCoverageType = (value) => (
    normalizeEnum(value, COVERAGE_TYPE_OPTIONS.map((o) => o.value))
);

export const normalizeRefundCalculationBasis = (value) => (
    normalizeEnum(value, REFUND_CALCULATION_BASIS_OPTIONS.map((o) => o.value))
);

export const normalizePaymentSchedule = (value) => (
    normalizeEnum(value, PAYMENT_SCHEDULE_OPTIONS.map((o) => o.value)) || 'end_of_stay'
);

/** Validation commune des champs subcoverage_trip rendus obligatoires. */
export const validateRequiredSubcoverageTripFields = (data) => {
    const errors = {};
    if (!normalizeCoverageType(data?.coverage_type)) {
        errors.coverage_type = 'Le type de couverture est obligatoire (maintain, cancellation ou maintain_and_cancellation).';
    }
    if (!normalizeRefundCalculationBasis(data?.refund_calculation_basis)) {
        errors.refund_calculation_basis = 'La base de calcul du remboursement est obligatoire (day ou night).';
    }
    if (!normalizePaymentSchedule(data?.payment_schedule)) {
        errors.payment_schedule = 'Le plan de paiement est obligatoire (daily ou end_of_stay).';
    }
    const weather = Array.isArray(data?.weather_parameter) ? data.weather_parameter.filter(Boolean) : [];
    if (weather.length === 0) {
        errors.weather_parameter = 'Au moins un paramètre météo est requis.';
    }
    return errors;
};
